<script setup lang="ts">
interface Props {
  variant?: 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning'
  size?: 'xs' | 'sm' | 'md'
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
  size: 'md'
})

const variants = {
  default: 'bg-white/10 text-foreground border-oxo-border',
  primary: 'bg-oxo-red text-white border-oxo-red',
  secondary: 'bg-oxo-yellow text-black border-oxo-yellow',
  info: 'bg-blue-700 text-white border-blue-600',
  success: 'bg-green-700 text-white border-green-600',
  warning: 'bg-purple-600 text-white border-purple-500'
}

const sizes = {
  xs: 'px-1.5 py-0.5 text-[10px] leading-none',
  sm: 'px-2.5 py-1 text-[10px]',
  md: 'px-4 py-1.5 text-[10px]'
}
</script>

<template>
  <span 
    class="inline-flex items-center justify-center rounded-full font-black uppercase tracking-widest border backdrop-blur-xs shadow-lg"
    :class="[variants[variant], sizes[size]]"
  >
    <slot />
  </span>
</template>
